module.exports = __webpack_public_path__ + "img/62.fe3c7007.jpg";